// tslint:disable:max-line-length
import { Injectable } from '@angular/core';
import { ListSearchService, ListItemModel } from 'e5core-angular-services';
import { KeyValuePair } from '../util/key-value-pair';
import { of, Observable, BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root'
  })
export class CachedListSearchService {

	cache: KeyValuePair[] = [];

	constructor(private listService: ListSearchService) {
	}

	public search(listId: any, options: any): BehaviorSubject<ListItemModel[]> {
		let subject$ = new BehaviorSubject<ListItemModel[]>([]) ;

		var cacheKey = listId;
		if (options !== undefined)
			cacheKey = cacheKey + options.parentListItemId;

		var cachedItem = this.cache.filter(f => f.key == cacheKey);
		if (cachedItem.length > 0) {
			subject$.next(cachedItem[0].value);
			return (subject$);
		}

		this.listService.search(listId, options).subscribe(
			list => {
				// TODO : Add "field.isSystemProperty"
				if(listId != "Category1_Id" && listId != "Category2_Id" && listId != "Category3_Id" && listId != "Status_Id") {
					list.unshift(<ListItemModel>{ id: "-2", code: "",  label: "(no value)"}) ;	
					list.unshift(<ListItemModel>{ id: "-1", code: "",  label: "(any value)"}) ;	
				}
				list.unshift(<ListItemModel>{ id: "0", code: "",  label: ""}) ;	

				this.cache.push({key: cacheKey, value: list});
				subject$.next(list);
			},
			error => {
				console.error(error);
				subject$.error(error);
			}
		);
		return (subject$);
	}
}